var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 194,
    viewBox: "0 0 345 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 344.8,
    height: 194,
    rx: 16,
    fill: "url(#paint0_linear_14398_10977)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.373 107.747L186.592 91.9083C184.295 86.535 180.07 86.3183 177.232 91.4316L173.137 98.82C171.057 102.568 167.178 102.893 164.492 99.535L164.015 98.9283C161.22 95.4183 157.277 95.8516 155.262 99.86L151.535 107.335C148.913 112.535 152.705 118.667 158.512 118.667H186.158C191.792 118.667 195.583 112.925 193.373 107.747Z",
    stroke: "#666666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.501 88.3333C165.091 88.3333 168.001 85.4231 168.001 81.8333C168.001 78.2434 165.091 75.3333 161.501 75.3333C157.912 75.3333 155.001 78.2434 155.001 81.8333C155.001 85.4231 157.912 88.3333 161.501 88.3333Z",
    stroke: "#666666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14398_10977",
    x1: 172.4,
    y1: 0,
    x2: 172.4,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-placeholder.44d8d59f9ab9a0fde3c12ed4cb954757.svg";
export { ForwardRef as ReactComponent };